export const channelList = [
  { label: '全部', id: '' },
  { label: 'H5', id: 1 },
  { label: '小程序', id: 0 },
];

export const objectList = [
  { label: '全平台', value: 0, key: '' },
  { label: '城市', value: 1, key: 'city' },
  { label: '商圈', value: 2, key: 'cbd' },
  { label: '企业', value: 3, key: 'company' },
];

export const targetDescNameList = ['businessDistrictName', 'cityName', 'companyName'];
